module.exports = __webpack_public_path__ + "static/media/Lato-Hairline.482fe0a9.woff";